export const CORE_DEPENDENCY = [
  '@viax/core-import-map',
  '@viax/admin',
  '@viax/core-root-config',
  '@viax/apollo-client',
  '@viax/page-not-found'
];

export const CORE_DEPENDENCY_IMPORT_MAP = {
  "@viax/admin": "https://mfa.viax.io/viax/admin/2.1.10/js/app.43b3e55d.js",
  "@viax/core-root-config": "https://mfa.viax.io/viax/core-root-config/1.15.5/viax-core-root-config.js",
  "@viax/apollo-client": "https://mfa.viax.io/viax/apollo-client/1.8.1/viax-apollo-client.js",
  "@viax/page-not-found": "https://mfa.viax.io/viax/page-not-found/1.0.3/js/app.3d0d2ea2.js"
}
